(function () {
    "use strict";

    angular
        .module("UndergroundWebApp")
        .controller("StatisticModalController", StatisticModalController);

    StatisticModalController.$inject = [
        "$scope",
        "accessItemsService",
        "$translate",
        "dataItem",
    ];

    function StatisticModalController(
        $scope,
        accessItemsService,
        $translate,
        dataItem
    ) {
        $scope.locationId = null;
        $scope.dateRange = {
                value: "month",
                label: $translate.instant("CONTSANT_DATE_RANGE_MONTH"),
                setter: (date) => date.setMonth(date.getMonth() - 1),
            };

        $scope.charts = [];
        $scope.getChartData = getChartData;
        $scope.processChartData = processChartData;
        $scope.dataItem = dataItem;

        $scope.dateRangeOptions = [
            {
                value: "week",
                label: $translate.instant("CONTSANT_DATE_RANGE_WEEK"),
                setter: (date) => date.setDate(date.getDate() - 7),
            },
            {
                value: "half-month",
                label: $translate.instant("CONTSANT_DATE_RANGE_HALF_MONTH"),
                setter: (date) => date.setDate(date.getDate() - 15),
            },
            {
                value: "month",
                label: $translate.instant("CONTSANT_DATE_RANGE_MONTH"),
                setter: (date) => date.setMonth(date.getMonth() - 1),
            },
            {
                value: "custom",
                label: $translate.instant("CONTSANT_DATE_RANGE_CUSTOM"),
            },
        ];

        function getChartData() {
            accessItemsService
                .getOpenAccessEvents(
                    dataItem.cardNumber,
                    moment($scope.dateRange.from).format("YYYY-MM-DD"),
                    moment($scope.dateRange.to).format("YYYY-MM-DD")
                )
                .then(function (statistics) {
                    var charts = {
                        dataSource: {
                            data: $scope.processChartData(statistics)
                        },
                        series: [{
                            type: "column",
                            field: "count",
                            categoryField: "date",
                            color: "purple",
                            labels: {
                                visible: true,
                                position: "top",
                                format: "{0}"  // format the label as needed
                            }
                        }],
                        categoryAxis: {
                            labels: {
                                rotation: -45
                            },
                        },
                        valueAxis: {
                            min: 0,
                            majorUnit: 1,
                        },
                        tooltip: {
                            visible: true,
                            format: "{0}"
                        }
                    }


                    $scope.charts = [charts];
                });
        }

        function processChartData(data) {
            let groupedData = {};
            
            data.forEach(item => {
                let date = item.eventData.access.event.time.split("T")[0]; // Extract YYYY-MM-DD
                groupedData[date] = (groupedData[date] || 0) + 1;
            });
        
            // Convert to array format for Kendo
            return Object.keys(groupedData).map(date => ({
                date: date,
                count: groupedData[date]
            }));
        };

    }
})();
